export const IS_UPGRADE_OVA = {
	result: true,
	time_left: 123,
};
